var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConcave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 132,
    viewBox: "0 0 74 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_91_16",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 74,
    height: 132
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 132,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_91_16)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_91_16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-40 169.282L-39.9998 169.282V180.907H-40V169.282ZM18.7157 66.6499C18.7157 90.6621 11.6047 113.013 -0.626228 131.713H72.9694C60.7385 113.013 53.6275 90.6621 53.6275 66.6499C53.6275 41.9547 61.1488 19.0161 74.0256 0L-1.6824 0C11.1944 19.0161 18.7157 41.9547 18.7157 66.6499Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-40 169.282L-39.9998 169.282V180.907H-40V169.282ZM18.7157 66.6499C18.7157 90.6621 11.6047 113.013 -0.626228 131.713H72.9694C60.7385 113.013 53.6275 90.6621 53.6275 66.6499C53.6275 41.9547 61.1488 19.0161 74.0256 0L-1.6824 0C11.1944 19.0161 18.7157 41.9547 18.7157 66.6499Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39.9998 169.282H-37.9998V165.864L-40.9798 167.539L-39.9998 169.282ZM-40 169.282L-40.98 167.539L-42 168.112V169.282H-40ZM-39.9998 180.907V182.907H-37.9998V180.907H-39.9998ZM-40 180.907H-42V182.907H-40V180.907ZM-0.626228 131.713L-2.29999 130.618L-4.32421 133.713H-0.626228V131.713ZM72.9694 131.713V133.713H76.6674L74.6432 130.618L72.9694 131.713ZM74.0256 0L75.6816 1.12139L77.7953 -2L74.0256 -2V0ZM-1.6824 0V-2L-5.4521 -2L-3.33844 1.12139L-1.6824 0ZM-40.9798 167.539L-40.98 167.539L-39.02 171.026L-39.0198 171.026L-40.9798 167.539ZM-37.9998 180.907V169.282H-41.9998V180.907H-37.9998ZM-40 182.907H-39.9998V178.907H-40V182.907ZM-42 169.282V180.907H-38V169.282H-42ZM1.04753 132.808C13.4848 113.793 20.7157 91.0627 20.7157 66.6499H16.7157C16.7157 90.2616 9.72458 112.234 -2.29999 130.618L1.04753 132.808ZM72.9694 129.713H-0.626228V133.713H72.9694V129.713ZM51.6275 66.6499C51.6275 91.0627 58.8583 113.793 71.2956 132.808L74.6432 130.618C62.6186 112.234 55.6275 90.2616 55.6275 66.6499H51.6275ZM72.3695 -1.12139C59.2757 18.2153 51.6275 41.5425 51.6275 66.6499H55.6275C55.6275 42.3669 63.0219 19.817 75.6816 1.12139L72.3695 -1.12139ZM74.0256 -2L-1.6824 -2V2L74.0256 2V-2ZM20.7157 66.6499C20.7157 41.5425 13.0675 18.2153 -0.0263557 -1.12139L-3.33844 1.12139C9.32126 19.817 16.7157 42.3669 16.7157 66.6499H20.7157Z",
    fill: "black",
    mask: "url(#path-2-inside-1_91_16)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcave);
export default __webpack_public_path__ + "static/media/concave.a497d8e0859773fe4d18907a8f9cbbe1.svg";
export { ForwardRef as ReactComponent };